'use client';

import { useRouter } from 'next/navigation';

export default function MobileSearchButton() {
  const router = useRouter();
  return (
    <button
      onClick={() => router.push('/search')}
      className="rounded-md border border-gf-border bg-gf-surface2 p-1.5 text-xs md:hidden"
      aria-label="Search"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="11" cy="11" r="8" />
        <path d="m21 21-4.3-4.3" />
      </svg>
    </button>
  );
}
